import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Button from '@material-ui/core/Button'
import EditIcon from '@material-ui/icons/Edit'
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye'
import DoneIcon from '@material-ui/icons/Done'
import * as constants from '../../../constants'

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
})

class OperationModeMenu extends React.Component {
  render() {
    const { classes, type, userType, editMode, operationMode, anchorEl, handleClickListItem, handleClose, handleMenuItemClick } = this.props

    var options = [
      { visible: true, name: 'Edit', icon: <EditIcon /> },
      { visible: true, name: 'View', icon: <RemoveRedEyeIcon /> },
      { visible: true, name: 'Set', icon: <DoneIcon /> },
    ]
    switch (type) {
      case constants.boardType.LIVE_GAME:
        if (userType !== constants.userType.CONTRIBUTOR) {
          options[constants.operationModeType.EDIT].visible = false
        }
        options[constants.operationModeType.SET].visible = false
        break
      case constants.boardType.GAME_ANALYZE:
      case constants.boardType.WEB_BOARD:
        switch (editMode) {
          case constants.editModeType.NORMAL:
            options[constants.operationModeType.SET].visible = false
            break
          case constants.editModeType.PUZZLE:
            options[constants.operationModeType.VIEW].visible = false
            break
          default:
            break
        }
        break
      default:
        break
    }

    return (
      <div className={classes.root}>
        <Button onClick={handleClickListItem}>{options[operationMode].name}</Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {options.map((option, index) => {
            if (option.visible === false) {
              return (<div key={option.name}></div>)
            }
            return (
              <MenuItem
                key={option.name}
                selected={index === operationMode}
                onClick={event => handleMenuItemClick(event, index)}
              >
                <ListItemIcon>
                  {option.icon}
                </ListItemIcon>
                <ListItemText classes={{ primary: classes.primary }} inset primary={option.name} />
              </MenuItem>
            )
          })}
        </Menu>
      </div>
    )
  }
}

export default withStyles(styles)(OperationModeMenu)



// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/OperationModeMenu.js